import { render, staticRenderFns } from "./ElecInvoice.vue?vue&type=template&id=2a16535a&scoped=true&"
import script from "./ElecInvoice.vue?vue&type=script&lang=js&"
export * from "./ElecInvoice.vue?vue&type=script&lang=js&"
import style0 from "./ElecInvoice.vue?vue&type=style&index=0&id=2a16535a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a16535a",
  null
  
)

export default component.exports